import React, { useEffect, useState } from 'react';

import './styles.css';

import close from '../../../assets/images/close.svg';
import ampulheta from '../../../assets/images/ampulheta.svg';
import { Row, Col } from 'react-bootstrap';

// import LoadingComponent from '../../LoadingComponent';

// import api from '../../../services/api';

export const ModalReport = ({ handleClose, handleModal, profile = 'corretores' }) => {
  const [regionais, setRegionais] = useState([]);
  const [plantoes, setPlantoes] = useState([]);
  const [loading, setLoading] = useState(true);

  return (
    <>
    <div className="dash-modal">
      <div className="dash-modal-content lg">
        <button className="btn-close" onClick={() => handleClose()}><img src={close} /></button>
        <div className="dash-modal-header modal-report">
          <p>Gerando relatório, por favor aguarde</p>
        </div>
        <div className="dash-modal-body modal-report">
          <img src={ampulheta} alt="Icon" />
          <p>Importante: os dados são atualizados diariamente.</p>
          <p>Alterações de cadastro serão exibidas somente no dia posterior à alteração.</p>
          {/* <LoadingComponent loading={loading} /> */}
        </div>
        <div className="dash-modal-footer">
          {/*Botão apenas para demonstrar o segundo modal, retirar depois */}
          {/* <button className="btn-save-shifts" onClick={() => handleModal()}>Ok</button> */}
        </div>
      </div>
    </div>
    </>
  );

}

export default ModalReport;